// extracted by mini-css-extract-plugin
export default {"grid":"stats_grid__m-bCy"};